import { storableError } from '../../util/errors';
import { convertUnitToSubUnit, unitDivisor } from '../../util/currency';
import { util as sdkUtil } from '../../util/sdkLoader';

import {
  parseDateFromISO8601,
  getExclusiveEndDate,
  addTime,
  subtractTime,
  daysBetween,
  getStartOf,
} from '../../util/dates';
import { createImageVariantConfig } from '../../util/sdkLoader';
import { isOriginInUse, isStockInUse } from '../../util/search';
import { parse } from '../../util/urlHelpers';
import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { fetchAllMerchantApi } from '../../util/api';

// Pagination page size might need to be dynamic on responsive page layouts
// Current design has max 3 columns 12 is divisible by 2 and 3
// So, there's enough cards to fill all columns on full pagination pages
const RESULT_PAGE_SIZE = 9;

// ================ Action types ================ //

export const SEARCH_LISTINGS_REQUEST = 'app/SearchPage/SEARCH_LISTINGS_REQUEST';
export const SEARCH_LISTINGS_SUCCESS = 'app/SearchPage/SEARCH_LISTINGS_SUCCESS';
export const SEARCH_LISTINGS_ERROR = 'app/SearchPage/SEARCH_LISTINGS_ERROR';

export const FETCH_USER_REQUEST = 'app/SearchPage/FETCH_USER_REQUEST';
export const FETCH_USER_SUCCESS = 'app/SearchPage/FETCH_USER_SUCCESS';
export const FETCH_MERCHANT_SUCCESS = 'app/SearchPage/FETCH_MERCHANT_SUCCESS';
export const FETCH_USER_ERROR = 'app/SearchPage/SFETCH_USER_ERROR';

export const SEARCH_MAP_LISTINGS_REQUEST = 'app/SearchPage/SEARCH_MAP_LISTINGS_REQUEST';
export const SEARCH_MAP_LISTINGS_SUCCESS = 'app/SearchPage/SEARCH_MAP_LISTINGS_SUCCESS';
export const SEARCH_MAP_LISTINGS_ERROR = 'app/SearchPage/SEARCH_MAP_LISTINGS_ERROR';

export const SEARCH_MAP_SET_ACTIVE_LISTING = 'app/SearchPage/SEARCH_MAP_SET_ACTIVE_LISTING';

export const SEARCH_LISTINGS_CUSTOM_SUCCESS = 'app/SearchPage/SEARCH_LISTINGS_CUSTOM_SUCCESS';

export const SEARCH_FILTER_REQUEST = 'app/SearchPage/SEARCH_FILTER_REQUEST';
export const SEARCH_FILTER_SUCCESS = 'app/SearchPage/SEARCH_FILTER_SUCCESS';
export const SEARCH_FILTER_ERROR = 'app/SearchPage/SEARCH_FILTER_ERROR';

// ================ Reducer ================ //

const initialState = {
  pagination: null,
  searchParams: null,
  searchInProgress: false,
  searchListingsError: null,
  currentPageResultIds: [],
  fetchUserInProgress: false,
  fetchUserError: null,
  currentMerchantResultIds: [],
  customPageResultIds: [],
  subCatergoriesOptions: [
     // products
  { option: 'appliances', value: 'appliances', label: 'Appliances', parentId: 'products' },
  { option: 'hobby_toy_games', value: 'hobby_toy_games', label: 'Hobby, Toy & Games', parentId: 'products' },
  { option: 'arts_crafts_sewing', value: 'arts_crafts_sewing', label: 'Arts, Crafts & Sewing', parentId: 'products' },
  { option: 'automotive', value: 'automotive', label: 'Automotive ', parentId: 'products' },
  { option: 'pet_products', value: 'pet_products', label: 'Pet Products', parentId: 'products' },
  { option: 'apparel_and_accessories', value: 'apparel_and_accessories', label: 'Apparel and Accessories', parentId: 'products' },
  { option: 'collectibles_fine_art', value: 'collectibles_fine_art', label: 'Collectibles & Fine Art', parentId: 'products' },
  { option: 'consumer_electronics', value: 'consumer_electronics', label: 'Consumer Electronics', parentId: 'products' },
  { option: 'secondhand_novelty', value: 'secondhand_novelty', label: 'Secondhand & Novelty', parentId: 'products' },
  { option: 'grocery_pharmacy', value: 'grocery_pharmacy', label: 'Grocery & Pharmacy', parentId: 'products' },
  { option: 'home_goods_furnishings', value: 'home_goods_furnishings', label: 'Home Goods & Furnishings', parentId: 'products' },
  { option: 'handmade', value: 'handmade', label: 'Handmade ', parentId: 'products' },
  { option: 'personal_care', value: 'personal_care', label: 'Personal Care', parentId: 'products' },
  { option: 'books_and_music', value: 'books_and_music', label: 'Books and Music', parentId: 'products' },
  { option: 'outdoor_living', value: 'outdoor_living', label: 'Outdoor Living', parentId: 'products' },
  { option: 'boating_and_rv_products', value: 'boating_and_rv_products', label: 'Boating and RV Products', parentId: 'products' },
  { option: 'nursery_garden_center_farming', value: 'nursery_garden_center_farming', label: 'Nursery, Garden Center, Farming', parentId: 'products' },
  { option: 'sporting_goods', value: 'sporting_goods', label: 'Sporting Goods', parentId: 'products' },

  // services
  { option: 'arts_entertainment', value: 'arts_entertainment', label: 'Arts & Entertainment ', parentId: 'services' },
  { option: 'medical_dental_vision', value: 'medical_dental_vision', label: 'Medical / Dental / Vision', parentId: 'services' },
  { option: 'health_wellness', value: 'health_wellness', label: 'Health & Wellness', parentId: 'services' },
  { option: 'personal_family_services', value: 'personal_family_services', label: 'Personal & Family Services', parentId: 'services' },
  { option: 'business_services', value: 'business_services', label: 'Business Services', parentId: 'services' },
  { option: 'professional_services', value: 'professional_services', label: 'Professional Services', parentId: 'services' },
  { option: 'rentals', value: 'rentals', label: 'Rentals', parentId: 'services' },
  { option: 'personal_care_beauty', value: 'personal_care_beauty', label: 'Personal Care & Beauty', parentId: 'services' },
  { option: 'spiritual', value: 'spiritual', label: 'Spiritual', parentId: 'services' },
  { option: 'real_estate', value: 'real_estate', label: 'Real Estate', parentId: 'services' },
  { option: 'auto_repair', value: 'auto_repair', label: 'Auto Repair', parentId: 'services' },
  { option: 'lawn_and_garden', value: 'lawn_and_garden', label: 'Lawn and Garden', parentId: 'services' },
  { option: 'boat_rv', value: 'boat_rv', label: 'Boat & RV', parentId: 'services' },
  { option: 'lessons_instruction', value: 'lessons_instruction', label: 'Lessons / Instruction', parentId: 'services' },
  { option: 'pet_services', value: 'pet_services', label: 'Pet Services', parentId: 'services' },
  { option: 'lodging_and_transportation', value: 'lodging_and_transportation', label: 'Lodging and Transportation', parentId: 'services' },
  { option: 'electronics_and_appliance_repair', value: 'electronics_and_appliance_repair', label: 'Electronics and Appliance Repair', parentId: 'services' },
  { option: 'home_services', value: 'home_services', label: 'Home Services', parentId: 'services' },
  { option: 'sport_fitness', value: 'sport_fitness', label: 'Sport & Fitness', parentId: 'services' },
  { option: 'adventure_recreation', value: 'adventure_recreation', label: 'Adventure & Recreation', parentId: 'services' },
  { option: 'event_services', value: 'event_services', label: 'Event Services', parentId: 'services' },
  { option: 'religious', value: 'religious', label: 'Religious ', parentId: 'services' },
  // Food and drinks 

  { option: 'cuisine', value: 'cuisine', label: 'Cuisine', parentId: 'food_Drinks' },
  { option: 'restaurant_type', value: 'restaurant_type', label: 'Restaurant Type', parentId: 'food_Drinks' },
  { option: 'diet_options', value: 'diet_options', label: 'Diet Options', parentId: 'food_Drinks' },
  { option: 'dining_options', value: 'dining_options', label: 'Dining Options', parentId: 'food_Drinks' },
  { option: 'Restaurant Features', value: 'Restaurant Features', label: 'Restaurant Features', parentId: 'food_Drinks' },
  ],
};

let listings = [];

const resultIds = data => data.data.map(l => l.id);

const listingPageReducer = (state = initialState, action = {}) => {
  
  const { type, payload } = action;
  switch (type) {
    case SEARCH_LISTINGS_REQUEST:
      listings = [];
      return {
        ...state,
        searchParams: payload.searchParams,
        searchInProgress: true,
        currentPageResultUsers: [],
        searchListingsError: null,
      };
    case SEARCH_LISTINGS_SUCCESS:
      return {
        ...state,
        currentPageResultIds: resultIds(payload.data),
        pagination: payload.data.meta,
        searchInProgress: false,
      };
    case SEARCH_LISTINGS_ERROR:

      // eslint-disable-next-line no-console
      console.error(payload);
      return { ...state, searchInProgress: false, searchListingsError: payload };

    case SEARCH_LISTINGS_CUSTOM_SUCCESS:
      listings.push(payload.data.data);
      const mergedListings = [].concat.apply([], listings);
      const ids = mergedListings && mergedListings.map(l => l.id);

      let uniqueArr =
        ids &&
        ids.length &&
        ids.reduce((unique, o) => {
          if (!unique.some(obj => obj['_sdkType'] === o['_sdkType'] && obj.uuid === o.uuid)) {
            unique.push(o);
          }
          return unique;
        }, []);

      return {
        ...state,
        customPageResultIds: uniqueArr,
        searchInProgress: false,
        searchAllListingsInProgress: false,
      };

    case FETCH_USER_REQUEST:
      return {
        ...state,
        fetchUserInProgress: true,
        fetchUserError: null,
      };
    case FETCH_USER_SUCCESS:
      return {
        ...state,
        currentMerchantResultIds: resultIds(payload.data),
        fetchUserInProgress: false,
      };
    case FETCH_USER_ERROR:
      console.error(payload);
      return { ...state, fetchUserInProgress: false, fetchUserError: payload };

    case SEARCH_MAP_SET_ACTIVE_LISTING:
      return {
        ...state,
        activeListingId: payload,
      };

    case SEARCH_FILTER_REQUEST:
      return {
        ...state,
        searchFilterInProgress: true,
        searchMapListingIds: [],
        searchFilterError: null,
      };
    case SEARCH_FILTER_SUCCESS:
      return {
        ...state,
        filterProducts: payload.data,
        searchFilterInProgress: false,
      };
    case SEARCH_FILTER_ERROR:
      // eslint-disable-next-line no-console
      console.error(payload);
      return { ...state, searchFilterInProgress: false, searchFilterError: payload };
    default:
      return state;
  }
};

export default listingPageReducer;

// ================ Action creators ================ //

export const searchListingsRequest = searchParams => ({
  type: SEARCH_LISTINGS_REQUEST,
  payload: { searchParams },
});

export const searchListingsSuccess = response => (
  {
  type: SEARCH_LISTINGS_SUCCESS,
  payload: { data: response.data },
});

export const searchListingsError = e => ({
  type: SEARCH_LISTINGS_ERROR,
  error: true,
  payload: e,
});
export const fetchUserRequest = searchParams => ({
  type: FETCH_USER_REQUEST,
});

export const fetchUserSuccess = response => ({
  type: FETCH_USER_SUCCESS,
  payload: { data: response },
});
export const fetchMerchantsSuccess = response => ({
  type: FETCH_MERCHANT_SUCCESS,
  payload: { data: response },
});

export const fetchUserError = e => ({
  type: FETCH_USER_ERROR,
  error: true,
  payload: e,
});

export const searchListingsCustomSuccess = response => ({
  type: SEARCH_LISTINGS_CUSTOM_SUCCESS,
  payload: { data: response.data },
});

export const searchFilterRequest = filterProducts => ({
  type: SEARCH_FILTER_REQUEST,
  payload: { filterProducts },
});

export const searchFilterSuccess = response => ({
  type: SEARCH_FILTER_SUCCESS,
  payload: { data: response },
});

export const searchFilterError = e => ({
  type: SEARCH_FILTER_ERROR,
  error: true,
  payload: e,
});

export const searchListings = (searchParams, config, params) => (dispatch, getState, sdk) => {
  dispatch(searchListingsRequest(searchParams));

  const searchValidListingTypes = listingTypes => {
    return config.listing.enforceValidListingType
      ? {
          pub_listingType: listingTypes.map(l => l.listingType),
        }
      : {};
  };

  const priceSearchParams = priceParam => {
    const inSubunits = value => convertUnitToSubUnit(value, unitDivisor(config.currency));
    const values = priceParam ? priceParam.split(',') : [];
    return priceParam && values.length === 2
      ? {
          price: [inSubunits(values[0]), inSubunits(values[1]) + 1].join(','),
        }
      : {};
  };

  const datesSearchParams = datesParam => {
    const searchTZ = 'Etc/UTC';
    const datesFilter = config.search.defaultFilters.find(f => f.key === 'dates');
    const values = datesParam ? datesParam.split(',') : [];
    const hasValues = datesFilter && datesParam && values.length === 2;
    const { dateRangeMode, availability } = datesFilter || {};
    const isNightlyMode = dateRangeMode === 'night';
    const isEntireRangeAvailable = availability === 'time-full';

    const getProlongedStart = date => subtractTime(date, 14, 'hours', searchTZ);
    const getProlongedEnd = date => addTime(date, 12, 'hours', searchTZ);

    const startDate = hasValues ? parseDateFromISO8601(values[0], searchTZ) : null;
    const endRaw = hasValues ? parseDateFromISO8601(values[1], searchTZ) : null;
    const endDate =
      hasValues && isNightlyMode
        ? endRaw
        : hasValues
        ? getExclusiveEndDate(endRaw, searchTZ)
        : null;

    const today = getStartOf(new Date(), 'day', searchTZ);
    const possibleStartDate = subtractTime(today, 14, 'hours', searchTZ);
    const hasValidDates =
      hasValues &&
      startDate.getTime() >= possibleStartDate.getTime() &&
      startDate.getTime() <= endDate.getTime();

    const dayCount = isEntireRangeAvailable ? daysBetween(startDate, endDate) : 1;
    const day = 1440;
    const hour = 60;

    const minDuration = isEntireRangeAvailable ? dayCount * day - hour : hour;
    return hasValidDates
      ? {
          start: getProlongedStart(startDate),
          end: getProlongedEnd(endDate),
          availability: 'time-partial',
          minDuration,
        }
      : {};
  };

  const { perPage, price, dates, sort, ...rest } = searchParams;
  const merchantType = searchParams?.pub_category == 'has_any:shop-by-food&drink,shop-by-merchants';
  const priceMaybe = priceSearchParams(price);
  const datesMaybe = datesSearchParams(dates);
  const sortMaybe = merchantType
    ? sort === config.search.sortConfig.relevanceKey
      ? {}
      : { sort: 'pub_createdAtDate' }
    : sort === config.search.sortConfig.relevanceKey
    ? {}
    : { sort };

  const params = {
    ...rest,
    ...priceMaybe,
    ...datesMaybe,
    ...sortMaybe,
    ...searchValidListingTypes(config.listing.listingTypes),
    perPage,
  };
  
  return sdk.listings
    .query({...params})
    .then(async response => {
      const { subCatergoriesOptions } = getState().SearchPage;
      const sanitizeConfig = { subCatergoriesOptions };
      dispatch(addMarketplaceEntities(response));
      dispatch(searchListingsCustomSuccess(response));
      dispatch(searchListingsSuccess(response));

      const meta = response && response.data && response.data.meta;
      const page = meta && meta.page;
      const { totalPages = 0, totalItems = 90 } = meta;

      const queryNextListings = async (page, totalPages) => {
        const newPage = page + 1;
        const res = await sdk.listings.query({ ...params, page: newPage, minStock: 1 });
        dispatch(addMarketplaceEntities(res, sanitizeConfig));
        dispatch(searchListingsCustomSuccess(res));

        const { totalItems = 90 } = meta;
        if (totalItems > 90 && totalPages !== newPage) {
          queryNextListings(newPage, totalPages);
        }
      };

      if (totalItems > 90 && totalPages !== page) {
        await queryNextListings(page, totalPages);
      }

      return response;
    })
    .catch(e => {
      dispatch(searchListingsError(storableError(e)));
      throw e;
    });
};


export const setActiveListing = listingId => ({
  type: SEARCH_MAP_SET_ACTIVE_LISTING,
  payload: listingId,
});

export const getAllMerchats = () => async dispatch => {
  try {
    dispatch(fetchUserRequest());
    fetchAllMerchantApi({
      pub_role: 'merchant',
      include: ['profileImage'],
      'fields.image': ['variants.square-small', 'variants.square-small2x'],
    })
      .then(response => {
        dispatch(addMarketplaceEntities(response));
        dispatch(fetchUserSuccess(response.data));
        return response;
      })
      .catch(e => dispatch(fetchUserError(storableError(e))));
  } catch (error) {
    return dispatch(fetchUserError(storableError(e)));
  }
};

export const loadData = (params, search, config) => dispatch => {
  const { type } = params;
  const queryParams = parse(search, {
    latlng: ['origin'],
    latlngBounds: ['bounds'],
  });

  // Add minStock filter with default value (1), if stock management is in use.
  // This can be overwriten with passed-in query parameters.
  const minStockMaybe = isStockInUse(config) ? { minStock: 1 } : {};
  const { page = 1, address, origin, ...rest } = queryParams;
  const originMaybe = isOriginInUse(config) && origin ? { origin } : {};
  const {
    aspectWidth = 1,
    aspectHeight = 1,
    variantPrefix = 'listing-card',
  } = config.layout.listingImage;
  const aspectRatio = aspectHeight / aspectWidth;

  const isTabMerchants = type=="shop-by-merchants";
  const typeFood = "shop-by-food&drink"
  const  pub_category =  isTabMerchants ? `has_any:${typeFood},${type}` : type;
  
  return dispatch(
    searchListings(
      {
        // ...minStockMaybe,
        pub_category,
        ...rest,
        ...originMaybe,
        page,
        perPage: RESULT_PAGE_SIZE,
        include: ['author', 'images', 'currentStock'],
        'fields.listing': ['title', 'geolocation', 'price', 'publicData'],
        'fields.user': ['profile.displayName', 'profile.abbreviatedName'],
        'fields.image': [
          `variants.${variantPrefix}`,
          `variants.${variantPrefix}-2x`,
          'variants.default',
        ],
        ...createImageVariantConfig(`${variantPrefix}`, 400, aspectRatio),
        ...createImageVariantConfig(`${variantPrefix}-2x`, 800, aspectRatio),
        'limit.images': 1,
      },
      config
    )
  );
};
